export enum ReportStatus {
  CONFIRMED = 'CONFIRMED',
  SUBMITTED = 'SUBMITTED'
}

export interface IllegalParkingReport {
  reportId: string;
  latitude: number;
  longitude: number;
  licensePlate?: string;
  state?: string;
  reason?: string;
  timestamp?: string;
  status?: ReportStatus;
  address?: string;
  presignedUrlsForImages?: string[];
  userId?: string;
  validImage: boolean;
  description?: string;
}
